import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SyncStatusBanner from './SyncStatusBanner';

// Routes that don't need MeLi sync status: public/marketing, auth, plan
// selection, the MeLi-connect flow itself, and admin.
const HIDDEN_ON_PATHS = [
  '/', '/login', '/register', '/forgot-password', '/reset-password',
  '/select-plan', '/subscription/return', '/connect-meli', '/auth/success',
  '/onboarding', '/privacy', '/admin',
];

// Mounted once above <Routes> so it survives navigation between pages instead
// of remounting per-page (which used to reset its dismissed state and polling).
const GlobalSyncBanner = () => {
  const { authToken, user } = useAuth();
  const location = useLocation();

  if (!authToken || !user?.meli_connected) return null;
  if (HIDDEN_ON_PATHS.includes(location.pathname)) return null;

  return (
    <div className="px-3 sm:px-6 lg:px-8">
      <div className="max-w-[1600px] mx-auto">
        <SyncStatusBanner />
      </div>
    </div>
  );
};

export default GlobalSyncBanner;
